import { render, staticRenderFns } from "./ExternalAccessLayout.vue?vue&type=template&id=21ddca5c&"
import script from "./ExternalAccessLayout.vue?vue&type=script&lang=ts&"
export * from "./ExternalAccessLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports